import moment from "moment";
import { Config } from "../../../../Utils/Config";

export const formatValue = (type, value) => {
    if (type === 'Number') return new Intl.NumberFormat().format(value);
    else if (type === 'Decimal') return new Intl.NumberFormat('en-GB', { minimumFractionDigits: 2 }).format(value);
    else if (type === 'Percentage') return new Intl.NumberFormat('en-GB', { minimumFractionDigits: 2 }).format(value).concat("%");
    else if (type === 'Currency') return (Config.Currency + new Intl.NumberFormat('en-GB').format(value));
    else if (type === 'Date') return moment(value).format("DD-MMM-YYYY");
}

export const numberAttr = [];
export const percentAttr = ["caprate", "occupancy"];
export const dateAttr = ["datelisted", "datesold", "dateofdeed"];
export const booleanAttr = ["confidential", "partofportfolio", "expansionpotential"];
export const priceAttr = ["salepriceselfreported", "saleprice", "listingprice", "salepricepublicsource", "noi", "priceperunit", "pricepersqft"];

export const attrNames = {
    docTitle: "Document Center",
    contactTitle: "Transaction Contacts",
    facTitle: "Facilities",
    deedTitle: "Deed Information",
    propertyName: "Property Name",
    address: "Address",
    country: "Country",
    descriptionexecutivesummary: "Description/Executive Summary",
    investmenthighlights: "Investment Highlights",
    datelisted: "Date Listed",
    datesold: "Date Sold",
    confidential: "Confidential",
    listingprice: "Listing Price",
    salepricepublicsource: "Sale Price - Public Source",
    salepriceselfreported: "Sale Price - Self Reported",
    partofportfolio: "Part of Portfolio",
    portfoliopercentage: "% of Portfolio",
    saletypename: "Sale Type Name",
    caprate: "Cap Rate",
    noi: "NOI",
    buyer: "Buyer",
    seller: "Seller",
    priceperunit: "Price Per Unit",
    pricepersqft: "Price Per SQFT",
    brokercompanyname: "Broker Company Name",
    contactpersonname: "Contact Person Name",
    phonenumber: "Phone",
    email: "Email",
    parkingspaces: "Parking Spaces",
    boatspaces: "Boat Spaces",
    rvspaces: "RV Spaces",
    cc: "CC",
    class: "Listing Class",
    expansionpotential: "Expansion Potential",
    parkingratio: "Parking Ratio",
    clearceilingheight: "Clear Ceiling Height",
    amenities: "Amenities",
    occupancy: "Occupancy at Listing",
    dateofdeed: "Date of Deed",
    deedtype: "Deed Type",
    deednumber: "Deed Number",
    deeddescription: "Deed Description",
    grantor: "Grantor",
    grantee: "Grantee",
    saleprice: "Sale Price",
    deeddocument: "Deed Document",
    transactionyear: "Transaction Year",
    page: "Page",
    book: "Book",
    sqft: "SQFT",
    nsrf: "NRSF",
    totalunits: "Total Units",
    yearbuilt: "Year Built",
    ownershiptype: "Ownership Type"
}